import type { TrackingResult } from "./types";

/**
 * Mock tracking data used until the `track` edge function is wired to
 * QuickManage (status) + Samsara (location). Single swap-point:
 * src/features/tracking/api.ts falls back to this when the backend is not yet
 * configured. (docs/ARCHITECTURE.md data flow for "Public tracking".)
 */
export function mockTracking(reference: string): TrackingResult {
  return {
    reference,
    status: "in_transit",
    origin: "Aurora, IL",
    destination: "Columbus, OH",
    location: {
      place: "Warsaw, IN",
      updatedAt: new Date().toISOString(),
    },
    eta: new Date(Date.now() + 6 * 3600_000).toISOString(),
    events: [
      { status: "booked", label: "Booked", timestamp: "2026-05-30T14:00:00Z", location: "Aurora, IL" },
      { status: "dispatched", label: "Dispatched", timestamp: "2026-05-31T09:30:00Z", location: "Aurora, IL" },
      { status: "in_transit", label: "In transit", timestamp: "2026-05-31T12:15:00Z", location: "I-65 near Lafayette, IN" },
    ],
  };
}
